/**
 * Coveo Query Suggestions for Coveo Search Box
 * Fetches and displays query suggestions from Coveo API
 */
// @ts-nocheck - Plain JS asset; window extensions and callbacks are untyped

// Prevent redeclaration if script is loaded multiple times
(function() {
    'use strict';
    
    // Check if already initialized
    if (typeof window.CoveoSearchBoxSuggestions !== 'undefined') {
      return;
    }

    class CoveoSearchBoxSuggestions {
    constructor(searchInput, suggestionsContainer) {
      this.searchInput = searchInput;
      this.suggestionsContainer = suggestionsContainer;
      this.minCharacters = 3;
      this.debounceTimeout = null;
      this.debounceDelay = 300; // ms
      this.currentAbortController = null;
      this.maxRecentSearches = 5; // Maximum number of recent searches to store
      this.storageKey = 'coveo_search_box_recent_searches'; // localStorage key
      
      // Configuration - will be populated from data attributes (set from shop metaobject)
      this.config = {
        organizationId: '',
        searchHub: '',
        token: '',
        locale: document.documentElement.lang || 'en',
        count: 5
      };
      
      this.selectedIndex = -1;
      this.suggestions = [];
      this.recentSearches = [];
      this.products = [];
      this.productsAbortController = null;
      this.maxProducts = 5; // Maximum number of products to display
      
      this.init();
    }
    
    showOverflowMask() {
      const mask = document.querySelector('.rs-overflow-mask');
      const headerGroup = document.querySelectorAll('.shopify-section-group-header-group');
      if (mask) {
        mask.style.display = 'block';
       
        if (headerGroup[1]) {headerGroup[1].style.zIndex = '1000';}
      }
    }
    
    hideOverflowMask() {
      const mask = document.querySelector('.rs-overflow-mask');
      const headerGroup = document.querySelectorAll('.shopify-section-group-header-group');
      if (mask) {
        mask.style.display = 'none';
        if (headerGroup[1]) {headerGroup[1].style.zIndex = '';}
      }
    }
    
    init() {
      // Get config from window.coveoConfig (populated from shop metaobject via script tag)
      // Wait a bit if config is not yet available (in case script loads before config is set)
      if (!window.coveoConfig) {
        console.warn('window.coveoConfig not found. Waiting 100ms and retrying...');
        setTimeout(() => {
          this.init();
        }, 100);
        return;
      }
      
      // Read values from window.coveoConfig
      this.config.organizationId = String(window.coveoConfig.organizationId || '').trim();
      this.config.searchHub = String(window.coveoConfig.searchHub || '').trim();
      this.config.token = String(window.coveoConfig.token || '').trim();
      this.config.locale = window.coveoConfig.locale || this.config.locale;
      this.config.company_id = window.coveoConfig.company_id || '';
      this.config.sales_area_id = window.coveoConfig.sales_area_id || '';
      this.config.catalogs = window.coveoConfig.catalogs || [];
      this.config.visible_countries = window.coveoConfig.visible_countries || [];
      this.config.market = window.coveoConfig.market || '';
      const ctx = window.coveoConfig.context;
      this.config.context =
        ctx && typeof ctx === 'object' && !Array.isArray(ctx)
          ? { userRole: 'b2bUser', ...ctx }
          : { userRole: 'b2bUser', language: this.config.locale };
      if (!this.config.context.language && this.config.locale) {
        this.config.context.language = this.config.locale;
      }
      
      
      // Validate required configuration (searchHub is optional)
      if (!this.config.organizationId || !this.config.token) {
        console.warn('Coveo configuration is incomplete. Query suggestions will be disabled. Please check shop metaobject (resideo_global_config) settings:', {
          organizationId: this.config.organizationId || '(empty)',
          searchHub: this.config.searchHub || '(empty - optional)',
          token: this.config.token ? '***' + this.config.token.slice(-10) : '(empty)',
          'Check metaobject': 'shop.metaobjects.resideo_global_config'
        });
        // Don't initialize event listeners if required config is missing
        return;
      }
      
      // Log if searchHub is missing (optional field)
      if (!this.config.searchHub) {
        console.info('Coveo searchHub is not set (optional field). Query suggestions will work without it.');
      }
      
      // Listen to input events
      this.searchInput.addEventListener('input', this.handleInput.bind(this));
      
      // Show recent searches on focus
      this.searchInput.addEventListener('focus', this.handleFocus.bind(this));
      
      // Hide suggestions when clicking outside
      document.addEventListener('click', this.handleClickOutside.bind(this));
      
      // Handle keyboard navigation
      this.searchInput.addEventListener('keydown', this.handleKeyDown.bind(this));
      
      // Clear button: show/hide based on input value, clear text on click
      const form = this.searchInput.closest('form');
      this.clearButton = form ? form.querySelector('.coveo-search-box-clear') : null;
      if (this.clearButton) {
        this.clearButton.addEventListener('click', this.handleClearClick.bind(this));
      }

      if (form) {
        form.addEventListener('submit', this.handleFormSubmit.bind(this));
        
        // Ensure form submits correctly to /search
        form.addEventListener('submit', (e) => {
          const query = this.searchInput.value.trim();
          if (!query) {
            // Prevent submission if query is empty
            e.preventDefault();
            return false;
          }
          // Form will submit naturally with action="{{ routes.search_url }}" and name="q" input
        });
        
        // Handle regular submit button click
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener('click', (e) => {
            const query = this.searchInput.value.trim();
            if (query) {
              // Form will submit naturally
              // No need to prevent default
            } else {
              e.preventDefault();
            }
          });
        }
        
        // Handle button with part="submit-button" (from atomic components or shadow DOM)
        const setupSubmitButtonHandler = () => {
          // Look for button with part="submit-button" in the document
          const partSubmitButtons = document.querySelectorAll('[part="submit-button"]');
          partSubmitButtons.forEach(button => {
            // Remove existing listener if any (to avoid duplicates)
            const newButton = button.cloneNode(true);
            button.parentNode?.replaceChild(newButton, button);
            
            newButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const query = this.searchInput.value.trim();
              if (query) {
                // Submit the form
                form.submit();
              }
            });
          });
          
          // Also check inside shadow DOM if any atomic components are used
          const atomicComponents = document.querySelectorAll('atomic-search-box, atomic-commerce-search-box');
          atomicComponents.forEach(component => {
            if (component.shadowRoot) {
              const shadowSubmitButton = component.shadowRoot.querySelector('[part="submit-button"]');
              if (shadowSubmitButton && !shadowSubmitButton.dataset.coveoHandlerAttached) {
                shadowSubmitButton.dataset.coveoHandlerAttached = 'true';
                shadowSubmitButton.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // Get query from atomic component or regular input
                  const atomicInput = component.shadowRoot.querySelector('input[type="search"]') ||
                                    component.shadowRoot.querySelector('input');
                  const query = atomicInput?.value?.trim() || this.searchInput.value.trim();
                  
                  if (query) {
                    // Update the form input value
                    this.searchInput.value = query;
                    // Submit the form
                    form.submit();
                  }
                });
              }
            }
          });
        };
        
        // Setup handler immediately and retry if elements not ready
        setupSubmitButtonHandler();
        setTimeout(setupSubmitButtonHandler, 500);
        setTimeout(setupSubmitButtonHandler, 1000);
        
        // Watch for dynamically added buttons with part="submit-button"
        const observer = new MutationObserver(() => {
          setupSubmitButtonHandler();
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      // Track selected suggestion index for keyboard navigation
      this.selectedIndex = -1;
      this.suggestions = [];
      this.recentSearches = [];

      // Whenever coveo-suggestions-visible is added to the container, show overflow mask
      const syncOverflowMask = () => {
        if (this.suggestionsContainer.classList.contains('coveo-suggestions-visible')) {
          this.showOverflowMask();
        } else {
          this.hideOverflowMask();
        }
      };
      const suggestionsObserver = new MutationObserver(syncOverflowMask);
      suggestionsObserver.observe(this.suggestionsContainer, {
        attributes: true,
        attributeFilter: ['class']
      });
      syncOverflowMask();

      this.updateClearButtonVisibility();
    }

    updateClearButtonVisibility() {
      if (!this.clearButton) return;
      const hasValue = this.searchInput.value.trim().length > 0;
      this.clearButton.style.display = hasValue ? 'flex' : 'none';
    }

    handleClearClick() {
      this.searchInput.value = '';
      this.searchInput.focus();
      this.hideSuggestions();
      this.updateClearButtonVisibility();
      this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    // Get recent searches from localStorage
    getRecentSearches() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (stored) {
          const searches = JSON.parse(stored);
          return Array.isArray(searches) ? searches : [];
        }
      } catch (error) {
        console.error('Error reading recent searches from localStorage:', error);
      }
      return [];
    }
    
    // Save a search query to recent searches
    saveRecentSearch(query) {
      if (!query || query.trim().length === 0) return;
      
      const trimmedQuery = query.trim();
      let recentSearches = this.getRecentSearches();
      
      // Remove if already exists (to move to top)
      recentSearches = recentSearches.filter(q => q.toLowerCase() !== trimmedQuery.toLowerCase());
      
      // Add to beginning
      recentSearches.unshift(trimmedQuery);
      
      // Keep only maxRecentSearches
      recentSearches = recentSearches.slice(0, this.maxRecentSearches);
      
      // Save to localStorage
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(recentSearches));
        this.recentSearches = recentSearches;
      } catch (error) {
        console.error('Error saving recent search to localStorage:', error);
      }
    }
    
    // Clear all recent searches
    clearRecentSearches() {
      try {
        localStorage.removeItem(this.storageKey);
        this.recentSearches = [];
      } catch (error) {
        console.error('Error clearing recent searches:', error);
      }
    }
    
    // Display recent searches in the dropdown
    displayRecentSearches() {
      this.recentSearches = this.getRecentSearches();
      
      if (this.recentSearches.length === 0) {
        this.hideSuggestions();
        return;
      }
      
      // Create recent searches HTML
      const recentHTML = this.recentSearches.map((search, index) => {
        return `
          <li 
            class="coveo-suggestion-item coveo-recent-search-item" 
            data-index="${index}"
            data-type="recent"
            role="option"
            tabindex="-1"
          >
            <button 
              type="button" 
              class="coveo-suggestion-button coveo-recent-search-button"
              data-suggestion="${this.escapeHtml(search)}"
            >
              <svg class="coveo-recent-search-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3504_14887)">
                  <mask id="mask0_3504_14887" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                    <path d="M6 0C7.18669 0 8.34728 0.352426 9.33398 1.01172C10.3204 1.67096 11.0889 2.60802 11.543 3.7041C11.997 4.80042 12.1163 6.00707 11.8848 7.1709C11.6532 8.33467 11.0822 9.40412 10.2432 10.2432C9.40412 11.0822 8.33467 11.6532 7.1709 11.8848C6.00707 12.1163 4.80042 11.997 3.7041 11.543C2.60802 11.0889 1.67096 10.3204 1.01172 9.33398C0.352426 8.34728 0 7.18669 0 6C1.89642e-05 5.74511 0.207024 5.53809 0.461914 5.53809C0.716633 5.53829 0.922833 5.74524 0.922852 6C0.922852 7.00408 1.22149 7.98544 1.7793 8.82031C2.33706 9.65499 3.12922 10.3062 4.05664 10.6904C4.98425 11.0747 6.00548 11.1753 6.99023 10.9795C7.97507 10.7836 8.87982 10.2999 9.58984 9.58984C10.2999 8.87982 10.7836 7.97507 10.9795 6.99023C11.1753 6.00548 11.0747 4.98425 10.6904 4.05664C10.3062 3.12922 9.65499 2.33706 8.82031 1.7793C7.9857 1.22166 7.00473 0.923038 6.00098 0.922852C4.57214 0.928519 3.20017 1.48636 2.17285 2.47949L1.5752 3.07715H3.53809C3.79286 3.07715 3.99979 3.28337 4 3.53809C4 3.79299 3.79299 4 3.53809 4H0.461914C0.431109 4.00002 0.40043 3.99634 0.370117 3.99023C0.348115 3.98581 0.327389 3.97814 0.306641 3.9707C0.300245 3.96842 0.293419 3.96742 0.287109 3.96484C0.264369 3.95553 0.243409 3.94333 0.222656 3.93066C0.217479 3.9275 0.211131 3.92623 0.206055 3.92285C0.081862 3.84014 0 3.69849 0 3.53809V0.461914C0 0.207012 0.207012 0 0.461914 0C0.716645 0.000201414 0.922852 0.207136 0.922852 0.461914V2.42383L1.53125 1.81641C2.73004 0.657505 4.33069 0.00633737 5.99805 0H6ZM6 2.46191C6.25483 2.46191 6.46179 2.66805 6.46191 2.92285V5.71484L8.66797 6.81836C8.89555 6.93241 8.98765 7.20873 8.87402 7.43652C8.76012 7.66434 8.48375 7.75714 8.25586 7.64355L5.79395 6.41309C5.63758 6.3349 5.53809 6.17482 5.53809 6V2.92285C5.53821 2.66806 5.74518 2.46193 6 2.46191Z" fill="black"/>
                  </mask>
                  <g mask="url(#mask0_3504_14887)">
                    <rect x="-26.1074" y="-26.1074" width="64.215" height="64.215" fill="#323232"/>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_3504_14887">
                    <rect width="12" height="12" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <span class="coveo-recent-search-text">${this.escapeHtml(search)}</span>
            </button>
          </li>
        `;
      }).join('');
      
      this.suggestionsContainer.innerHTML = `
        <div class="coveo-recent-searches-header">
          <span class="coveo-recent-searches-title">${window.__t('recent_searches')}</span>
        </div>
        <ul class="coveo-suggestions-list" role="listbox" aria-label="${window.__t('recent_searches')}">
          ${recentHTML}
        </ul>
        <a href="#" role="button" class="coveo-clear-recent-link" aria-label="${window.__t('clear_recent_searches')}">${window.__t('clear_recent_searches')}</a>
      `;
      
      // Show container and overflow mask
      this.suggestionsContainer.classList.add('coveo-suggestions-visible');
      this.searchInput.setAttribute('aria-expanded', 'true');
      this.showOverflowMask();
      
      // Add click handlers to recent search buttons
      this.suggestionsContainer.querySelectorAll('.coveo-recent-search-button').forEach((button, index) => {
        button.addEventListener('click', () => {
          this.selectSuggestion(this.recentSearches[index]);
        });
      });
      
      // Add click handler to clear recent link at bottom
      const clearButton = this.suggestionsContainer.querySelector('.coveo-clear-recent-link');
      if (clearButton) {
        clearButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.clearRecentSearches();
          this.hideSuggestions();
        });
      }
    }
    
    // Handle focus event - show recent searches if input is empty
    handleFocus(event) {
      const query = event.target.value.trim();
      
      // Show recent searches if input is empty or has less than minCharacters
      if (query.length < this.minCharacters) {
        this.displayRecentSearches();
      }
    }
    
    handleInput(event) {
      const query = event.target.value.trim();
      this.updateClearButtonVisibility();

      // Clear previous timeout
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      
      // Abort previous request if still pending
      if (this.currentAbortController) {
        this.currentAbortController.abort();
      }
      
      // Show recent searches only when search box is empty (e.g. after clear)
      if (query.length === 0) {
        this.displayRecentSearches();
        return;
      }
      
      // Do not show recent history when user has typed any character; hide until minCharacters
      if (query.length < this.minCharacters) {
        this.hideSuggestions();
        return;
      }
      
      // Debounce the API call
      this.debounceTimeout = setTimeout(() => {
        this.fetchSuggestions(query);
      }, this.debounceDelay);
    }
    
    // Display recent searches filtered by query
    displayFilteredRecentSearches(query) {
      this.recentSearches = this.getRecentSearches();
      const lowerQuery = query.toLowerCase();
      
      // Filter recent searches that match the query
      const filtered = this.recentSearches.filter(search => 
        search.toLowerCase().includes(lowerQuery)
      );
      
      if (filtered.length === 0) {
        this.displayNoResultsMessage(query);
        return;
      }

      // Create filtered recent searches HTML
      const recentHTML = filtered.map((search, index) => {
        const highlightedText = this.highlightQuery(search, query);
        return `
          <li 
            class="coveo-suggestion-item coveo-recent-search-item" 
            data-index="${index}"
            data-type="recent"
            role="option"
            tabindex="-1"
          >
            <button 
              type="button" 
              class="coveo-suggestion-button coveo-recent-search-button"
              data-suggestion="${this.escapeHtml(search)}"
            >
              <svg class="coveo-recent-search-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3504_14887)">
                  <mask id="mask0_3504_14887" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                    <path d="M6 0C7.18669 0 8.34728 0.352426 9.33398 1.01172C10.3204 1.67096 11.0889 2.60802 11.543 3.7041C11.997 4.80042 12.1163 6.00707 11.8848 7.1709C11.6532 8.33467 11.0822 9.40412 10.2432 10.2432C9.40412 11.0822 8.33467 11.6532 7.1709 11.8848C6.00707 12.1163 4.80042 11.997 3.7041 11.543C2.60802 11.0889 1.67096 10.3204 1.01172 9.33398C0.352426 8.34728 0 7.18669 0 6C1.89642e-05 5.74511 0.207024 5.53809 0.461914 5.53809C0.716633 5.53829 0.922833 5.74524 0.922852 6C0.922852 7.00408 1.22149 7.98544 1.7793 8.82031C2.33706 9.65499 3.12922 10.3062 4.05664 10.6904C4.98425 11.0747 6.00548 11.1753 6.99023 10.9795C7.97507 10.7836 8.87982 10.2999 9.58984 9.58984C10.2999 8.87982 10.7836 7.97507 10.9795 6.99023C11.1753 6.00548 11.0747 4.98425 10.6904 4.05664C10.3062 3.12922 9.65499 2.33706 8.82031 1.7793C7.9857 1.22166 7.00473 0.923038 6.00098 0.922852C4.57214 0.928519 3.20017 1.48636 2.17285 2.47949L1.5752 3.07715H3.53809C3.79286 3.07715 3.99979 3.28337 4 3.53809C4 3.79299 3.79299 4 3.53809 4H0.461914C0.431109 4.00002 0.40043 3.99634 0.370117 3.99023C0.348115 3.98581 0.327389 3.97814 0.306641 3.9707C0.300245 3.96842 0.293419 3.96742 0.287109 3.96484C0.264369 3.95553 0.243409 3.94333 0.222656 3.93066C0.217479 3.9275 0.211131 3.92623 0.206055 3.92285C0.081862 3.84014 0 3.69849 0 3.53809V0.461914C0 0.207012 0.207012 0 0.461914 0C0.716645 0.000201414 0.922852 0.207136 0.922852 0.461914V2.42383L1.53125 1.81641C2.73004 0.657505 4.33069 0.00633737 5.99805 0H6ZM6 2.46191C6.25483 2.46191 6.46179 2.66805 6.46191 2.92285V5.71484L8.66797 6.81836C8.89555 6.93241 8.98765 7.20873 8.87402 7.43652C8.76012 7.66434 8.48375 7.75714 8.25586 7.64355L5.79395 6.41309C5.63758 6.3349 5.53809 6.17482 5.53809 6V2.92285C5.53821 2.66806 5.74518 2.46193 6 2.46191Z" fill="black"/>
                  </mask>
                  <g mask="url(#mask0_3504_14887)">
                    <rect x="-26.1074" y="-26.1074" width="64.215" height="64.215" fill="#323232"/>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_3504_14887">
                    <rect width="12" height="12" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <span class="coveo-recent-search-text">${highlightedText}</span>
            </button>
          </li>
        `;
      }).join('');
      
      this.suggestionsContainer.innerHTML = `
        <div class="coveo-recent-searches-section">
          ${recentHTML}
        </div>
      `;
      
      // Show container and overflow mask
      this.suggestionsContainer.classList.add('coveo-suggestions-visible');
      this.searchInput.setAttribute('aria-expanded', 'true');
      this.showOverflowMask();
      
      // Add click handlers
      this.suggestionsContainer.querySelectorAll('.coveo-recent-search-button').forEach((button, index) => {
        button.addEventListener('click', () => {
          this.selectSuggestion(filtered[index]);
        });
      });
    }

    /**
     * Show a message when no suggestions or products are available.
     * Matches design: "No suggestions available" + separator + "Products (0 results)" with "See All Results" + "No products match your search".
     */
    displayNoResultsMessage(query) {
      const searchUrl = this.getSearchUrl(query);
      const translationEl = document.getElementById('rs-coveo-search-box-suggestion-translations');
      this.suggestionsContainer.innerHTML = `
        <div class="coveo-no-results">
          <p class="coveo-no-results-suggestions-msg">${translationEl?.dataset.noSuggestion || 'No suggestions available'}</p>
          <hr class="coveo-no-results-separator" aria-hidden="true">
          <div class="coveo-no-results-products-header">
            <span class="coveo-no-results-products-title"><strong>${translationEl?.dataset.products || 'Products'}</strong> (0 ${translationEl?.dataset.results || 'results'})</span>
            <a href="${this.escapeHtml(searchUrl)}" class="coveo-no-results-link">${translationEl?.dataset.seeAllResults || 'See All Results'}</a>
          </div>
          <p class="coveo-no-results-products-msg">${translationEl?.dataset.noProductsMatch || 'No products match your search'}</p>
        </div>
      `;
      this.suggestionsContainer.classList.add('coveo-suggestions-visible');
      this.searchInput.setAttribute('aria-expanded', 'true');
      this.showOverflowMask();
    }

    async fetchSuggestions(query) {
    //  console.log('fetchSuggestions called with query:', query);
      // Create new abort controller for this request
      this.currentAbortController = new AbortController();
      
      try {
        const body = {
          q: query,
          locale: this.config.locale,
          searchHub: this.config.searchHub,
          enableWordCompletion: true,
          count: this.config.count,
          context: { ...this.config.context }
        };

        // Fetch both suggestions and products in parallel
        const [suggestionsResponse, productsResponse] = await Promise.allSettled([
          fetch(
            `https://platform.cloud.coveo.com/rest/search/v2/querySuggest?organizationId=${this.config.organizationId}`,
            {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${this.config.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(body),
              signal: this.currentAbortController.signal
            }
          ),
          this.fetchProducts(query)
        ]);
        
        let suggestions = [];
        if (suggestionsResponse.status === 'fulfilled' && suggestionsResponse.value.ok) {
          const suggestionsData = await suggestionsResponse.value.json();
          suggestions = (suggestionsData.completions || []).filter(item => {
              const text = (item.expression || item).toLowerCase();
              return !(
                  text.startsWith("cat:") ||
                  text.startsWith("_cat:") ||
                  text.startsWith("tags") ||
                  text.startsWith("sku:") ||
                  text.startsWith("model:")
              );
          });
        }
        
        let products = [];
        let totalResults = 0;
        if (productsResponse.status === 'fulfilled') {
          products = productsResponse.value.products || [];
          totalResults = productsResponse.value.totalResults || 0;
        }
        
        if (!this.currentAbortController.signal.aborted) {
          this.displaySuggestions(suggestions, query, products, totalResults);
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          // Request was aborted, ignore
          return;
        }
        console.error('Error fetching Coveo query suggestions:', error);
        this.hideSuggestions();
      }
    }
    
    async fetchProducts(query) {
      // Abort previous products request
      if (this.productsAbortController) {
        this.productsAbortController.abort();
      }
      
      this.productsAbortController = new AbortController();
      try {
        const body = {
          analytics: { trackingId: JSON.parse(localStorage.getItem("coveo_shopify_config")).trackingId },
          q: query,
          locale: this.config.locale,
          searchHub: this.config.searchHub,
          numberOfResults: this.maxProducts,
          context: { ...this.config.context }
        };
        
        const response = await fetch(
          `https://platform.cloud.coveo.com/rest/search/v2?organizationId=${this.config.organizationId}`,
          {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${this.config.token}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(body),
            signal: this.productsAbortController.signal
          }
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        const visitorId = localStorage.getItem("visitorId");
        const ctxAnalytics = Object.entries(body.context).map(([key, value]) => [`context_${key}`, value]);
        const resAnalytics = fetch(
          `https://${this.config.organizationId}.analytics.org.coveo.com/rest/ua/v15/analytics/search?visitor=${visitorId}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.config.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              anonymous: false,
              actionCause: "searchboxAsYouType",
              clientId: visitorId,
              customData: {
                ...Object.fromEntries(ctxAnalytics),
              },
              language: body.locale,
              numberOfResults: data.totalCount,
              queryText: body.q,
              responseTime: data.duration,
              searchQueryUid: data.searchUid,
              originLevel1: body.searchHub,
              trackingId: JSON.parse(localStorage.getItem("coveo_shopify_config")).trackingId,
              userAgent: navigator.userAgent,
            })
          }
        );


        const isPdfUrl = (url) => {
          if (!url || typeof url !== 'string') return false;
          const path = url.split('?')[0];
          return path.toLowerCase().endsWith('.pdf');
        };
        const resultsExcludingPdf = (data.results || []).filter(
          result => !isPdfUrl(result.clickUri || result.uri || '')
        );
        const products = resultsExcludingPdf.map(result => {
          // Use primary_image_file_path first, then parse primary_image JSON, then other fallbacks
          let primaryImageUrl = result.raw?.primary_image_file_path || '';
          if (!primaryImageUrl && result.raw?.primary_image) {
            try {
              const primaryImage = typeof result.raw.primary_image === 'string' 
                ? JSON.parse(result.raw.primary_image) 
                : result.raw.primary_image;
              primaryImageUrl = primaryImage?.shopify_cdn_url || '';
            } catch (e) {
              console.warn('Error parsing primary_image JSON:', e);
            }
          }
          
          const thumbnail = primaryImageUrl || 
                           result.raw?.shopify_cdn_url || 
                           result.raw?.ec_image || 
                           result.raw?.ec_images?.[0] || 
                           result.raw?.ec_thumbnails || 
                           result.raw?.featured_media || '';

          
          const analytics = {
            documentPosition: data.results.indexOf(result) + 1 || 1,
            language: body.locale,
            searchQueryUid: data.searchUid,
            sourceName: result.raw?.source || '',
            originLevel1: body.searchHub,
            customData: {
              contentIDKey: result.raw?.permanentid ? 'permanentid' : '',
              contentIDValue: result.raw?.permanentid || '',
              ...Object.fromEntries(ctxAnalytics),
            },
            documentTitle: result.title || '',
            documentUrl: result.clickUri || '',
            trackingId: JSON.parse(localStorage.getItem("coveo_shopify_config")).trackingId,
            userAgent: navigator.userAgent,
          }

        
          return {
            title: result.raw?.sku_number || result.title || '',
            uri: result.uri || '',
            clickUri: result.clickUri || result.uri || '',
            thumbnail: thumbnail,
            model: result.raw?.sku_number || result.raw?.ec_sku || result.raw?.ec_product_id || '',
            description: result.excerpt || result.raw?.ec_description || '',
            analytics: analytics
          };
        });
        
        return {
          products: products,
          totalResults: products.length
        };
      } catch (error) {
        if (error.name === 'AbortError') {
          return { products: [], totalResults: 0 };
        }
        console.error('Error fetching Coveo products:', error);
        return { products: [], totalResults: 0 };
      }
    }
    
    displaySuggestions(suggestions, query, products = [], totalResults = 0) {
      this.suggestions = suggestions;
      this.products = products;
      this.selectedIndex = -1;
      
      // Do not show search history or recent-searches header when user has typed 3+ characters
      const showRecentSearches = query.length < this.minCharacters;
      let matchingRecent = [];
      if (showRecentSearches) {
        this.recentSearches = this.getRecentSearches();
        const lowerQuery = query.toLowerCase();
        matchingRecent = this.recentSearches.filter(search => 
          search.toLowerCase().includes(lowerQuery) && 
          !suggestions.some(s => (s.expression || s).toLowerCase() === search.toLowerCase())
        );
      }
      
      // If no suggestions, no matching recent, and no products, show no-results message
      if (suggestions.length === 0 && matchingRecent.length === 0 && products.length === 0) {
        this.displayNoResultsMessage(query);
        return;
      }

      // Create recent searches HTML (show on top) - only when query has fewer than minCharacters
      const recentHTML = showRecentSearches && matchingRecent.length > 0 ? `
        <div class="coveo-recent-searches-header">
          <span class="coveo-recent-searches-title">${window.__t('recent_searches')}</span>
        </div>
        <ul class="coveo-suggestions-list" role="listbox" aria-label="${window.__t('recent_searches')}">
          ${matchingRecent.map((search, index) => {
            const highlightedText = this.highlightQuery(search, query);
            return `
              <li 
                class="coveo-suggestion-item coveo-recent-search-item" 
                data-index="${index}"
                data-type="recent"
                role="option"
                tabindex="-1"
              >
                <button 
                  type="button" 
                  class="coveo-suggestion-button coveo-recent-search-button"
                  data-suggestion="${this.escapeHtml(search)}"
                >
                  <svg class="coveo-recent-search-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3504_14887)">
                  <mask id="mask0_3504_14887" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                    <path d="M6 0C7.18669 0 8.34728 0.352426 9.33398 1.01172C10.3204 1.67096 11.0889 2.60802 11.543 3.7041C11.997 4.80042 12.1163 6.00707 11.8848 7.1709C11.6532 8.33467 11.0822 9.40412 10.2432 10.2432C9.40412 11.0822 8.33467 11.6532 7.1709 11.8848C6.00707 12.1163 4.80042 11.997 3.7041 11.543C2.60802 11.0889 1.67096 10.3204 1.01172 9.33398C0.352426 8.34728 0 7.18669 0 6C1.89642e-05 5.74511 0.207024 5.53809 0.461914 5.53809C0.716633 5.53829 0.922833 5.74524 0.922852 6C0.922852 7.00408 1.22149 7.98544 1.7793 8.82031C2.33706 9.65499 3.12922 10.3062 4.05664 10.6904C4.98425 11.0747 6.00548 11.1753 6.99023 10.9795C7.97507 10.7836 8.87982 10.2999 9.58984 9.58984C10.2999 8.87982 10.7836 7.97507 10.9795 6.99023C11.1753 6.00548 11.0747 4.98425 10.6904 4.05664C10.3062 3.12922 9.65499 2.33706 8.82031 1.7793C7.9857 1.22166 7.00473 0.923038 6.00098 0.922852C4.57214 0.928519 3.20017 1.48636 2.17285 2.47949L1.5752 3.07715H3.53809C3.79286 3.07715 3.99979 3.28337 4 3.53809C4 3.79299 3.79299 4 3.53809 4H0.461914C0.431109 4.00002 0.40043 3.99634 0.370117 3.99023C0.348115 3.98581 0.327389 3.97814 0.306641 3.9707C0.300245 3.96842 0.293419 3.96742 0.287109 3.96484C0.264369 3.95553 0.243409 3.94333 0.222656 3.93066C0.217479 3.9275 0.211131 3.92623 0.206055 3.92285C0.081862 3.84014 0 3.69849 0 3.53809V0.461914C0 0.207012 0.207012 0 0.461914 0C0.716645 0.000201414 0.922852 0.207136 0.922852 0.461914V2.42383L1.53125 1.81641C2.73004 0.657505 4.33069 0.00633737 5.99805 0H6ZM6 2.46191C6.25483 2.46191 6.46179 2.66805 6.46191 2.92285V5.71484L8.66797 6.81836C8.89555 6.93241 8.98765 7.20873 8.87402 7.43652C8.76012 7.66434 8.48375 7.75714 8.25586 7.64355L5.79395 6.41309C5.63758 6.3349 5.53809 6.17482 5.53809 6V2.92285C5.53821 2.66806 5.74518 2.46193 6 2.46191Z" fill="black"/>
                  </mask>
                  <g mask="url(#mask0_3504_14887)">
                    <rect x="-26.1074" y="-26.1074" width="64.215" height="64.215" fill="#323232"/>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_3504_14887">
                    <rect width="12" height="12" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
                  <span class="coveo-recent-search-text">${highlightedText}</span>
                </button>
              </li>
            `;
          }).join('')}
        </ul>
        <a href="#" role="button" class="coveo-clear-recent-link" aria-label="${window.__t('clear_recent_searches')}">${window.__t('clear_recent_searches')}</a>
      ` : '';
      
      // Create suggestions HTML with search icon (show below recent searches)
      const suggestionsHTML = suggestions.length > 0 ? suggestions.map((suggestion, index) => {
        const suggestionText = suggestion.expression || suggestion;
        const highlightedText = this.highlightQuery(suggestionText, query);
        return `
          <li 
            class="coveo-suggestion-item" 
            data-index="${index}"
            data-type="suggestion"
            role="option"
            tabindex="-1"
          >
            <button 
              type="button" 
              class="coveo-suggestion-button coveo-query-suggestion-button"
              data-suggestion="${this.escapeHtml(suggestionText)}"
            >
              <svg class="coveo-suggestion-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.2002 0C11.1767 0 14.4004 3.22373 14.4004 7.2002C14.4004 8.89998 13.8093 10.4607 12.8242 11.6924L15.7656 14.6348C16.0779 14.9472 16.078 15.4532 15.7656 15.7656C15.4532 16.078 14.9472 16.0779 14.6348 15.7656L11.6924 12.8242C10.4607 13.8093 8.89998 14.4004 7.2002 14.4004C3.22373 14.4004 0 11.1767 0 7.2002C0 3.22369 3.22369 0 7.2002 0ZM7.2002 1.59961C4.10736 1.59961 1.59961 4.10736 1.59961 7.2002C1.59966 10.293 4.10739 12.7998 7.2002 12.7998C10.293 12.7998 12.7998 10.293 12.7998 7.2002C12.7998 4.10739 10.293 1.59966 7.2002 1.59961Z" fill="currentColor"/>
              </svg>
              <span class="coveo-suggestion-text">${highlightedText}</span>
            </button>
          </li>
        `;
      }).join('') : '';
      
      // Create products HTML (show at bottom)
      const translationEl = document.getElementById('rs-coveo-search-box-suggestion-translations');
      const productsHTML = products.length > 0 ? `
        <div class="coveo-products-section">
          <div class="coveo-products-header">
            <span class="coveo-products-title"><strong>${translationEl?.dataset.products || window.__t('products')}</strong> (${totalResults} ${translationEl?.dataset.results || window.__t('results')})</span>
            <a href="${this.getSearchUrl(query)}" class="coveo-see-all-results">${translationEl?.dataset.seeAllResults || window.__t('see_all_results')}</a>
          </div>
          <ul class="coveo-products-list" role="listbox" aria-label="${window.__t('products')}">
            ${products.map((product, index) => {
              const productTitle = this.escapeHtml(product.title || '');
              const productModel = this.escapeHtml(product.model || '');
              const productDescription = this.escapeHtml(product.description || '');
              const productUrl = this.escapeHtml(product.clickUri || product.uri || '#');
              const productImage = product.thumbnail || '';
              const hasImage = productImage && productImage.trim().length > 0;
              return `
                <li class="coveo-product-item" role="option" tabindex="-1">
                  <a href="${productUrl}" class="coveo-product-link">
                    ${hasImage ? `<img src="${this.escapeHtml(productImage)}" alt="${productTitle}" class="coveo-product-image" loading="lazy" onerror="this.onerror=null; this.style.display='none'; this.parentElement.querySelector('.coveo-product-image-placeholder').style.display='block';">` : ''}
                    <div class="coveo-product-image-placeholder" ${hasImage ? 'style="display:none;"' : ''}></div>
                    <div class="coveo-product-info">
                      
                      <div class="coveo-product-title">${productTitle}</div>
                      <div class="coveo-product-description">${productDescription}</div>
                    </div>
                  </a>
                </li>
              `;
            }).join('')}
          </ul>
        </div>
      ` : '';
      
      // Build HTML with recent searches first, then suggestions, then products
      this.suggestionsContainer.innerHTML = `
        ${recentHTML}
        ${suggestionsHTML ? `<ul class="coveo-suggestions-list" role="listbox" aria-label="${window.__t('query_suggestions')}">${suggestionsHTML}</ul>` : ''}
        ${productsHTML}
      `;
      
      // Show container and overflow mask
      this.suggestionsContainer.classList.add('coveo-suggestions-visible');
      this.searchInput.setAttribute('aria-expanded', 'true');
      this.showOverflowMask();
      
      // Add click handler to clear button (if present)
      const clearButton = this.suggestionsContainer.querySelector('.coveo-clear-recent-link');
      if (clearButton) {
        clearButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.clearRecentSearches();
          // Refresh the display
          if (this.searchInput.value.trim().length >= this.minCharacters) {
            this.fetchSuggestions(this.searchInput.value.trim());
          } else {
            this.displayRecentSearches();
          }
        });
      }
      
      // Add click handlers to recent search buttons
      this.suggestionsContainer.querySelectorAll('.coveo-recent-search-button').forEach((button, index) => {
        const suggestion = button.dataset.suggestion;
        button.addEventListener('click', () => {
          this.selectSuggestion(suggestion);
        });
      });
      
      // Add click handlers to suggestion buttons
      this.suggestionsContainer.querySelectorAll('.coveo-query-suggestion-button').forEach((button, index) => {
        button.addEventListener('click', () => {
          this.selectSuggestion(suggestions[index].expression || suggestions[index]);
        });
      });

      
      // Add click handler to product link "button"
      this.suggestionsContainer.querySelectorAll('.coveo-product-link').forEach((link, index) => {
        link.addEventListener('click', () => {
          const visitorId = localStorage.getItem('visitorId');
          fetch(
          `https://${this.config.organizationId}.analytics.org.coveo.com/rest/ua/v15/analytics/click?visitor=${visitorId}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.config.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              anonymous: false,
              actionCause: "documentOpen",
              clientId: visitorId,
              ...products[index].analytics,
            })
          }
        );
        })
      })

    }
    
    getSearchUrl(query) {
      const form = this.searchInput.closest('form');
      if (form && form.action) {
        return `${form.action}?q=${encodeURIComponent(query)}`;
      }
      return `/search?q=${encodeURIComponent(query)}`;
    }
    
    highlightQuery(text, query) {
      if (!query) return this.escapeHtml(text);
      
      const escapedText = this.escapeHtml(text);
      const escapedQuery = this.escapeHtml(query);
      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      
      return escapedText.replace(regex, '<mark>$1</mark>');
    }
    
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    hideSuggestions() {
      this.suggestionsContainer.classList.remove('coveo-suggestions-visible');
      this.suggestionsContainer.innerHTML = '';
      this.searchInput.setAttribute('aria-expanded', 'false');
      this.selectedIndex = -1;
      this.suggestions = [];
      this.hideOverflowMask();
    }
    
    selectSuggestion(suggestion) {
      this.searchInput.value = suggestion;
      this.hideSuggestions();
      
      // Save to recent searches
      this.saveRecentSearch(suggestion);
      
      // Trigger input event to update any other listeners
      this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      
      // Submit the search form so the user is taken to search results
      const form = this.searchInput.closest('form');
      if (form && suggestion && String(suggestion).trim()) {
        form.submit();
      } else {
        this.searchInput.focus();
      }
    }
    
    // Handle form submit to save search query
    handleFormSubmit(event) {
      const query = this.searchInput.value.trim();
      if (query.length > 0) {
        this.saveRecentSearch(query);
      }
    }
    
    handleKeyDown(event) {
      const items = this.suggestionsContainer.querySelectorAll('.coveo-suggestion-item');
      
      if (items.length === 0) return;
      
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1);
          this.updateSelection(items);
          break;
          
        case 'ArrowUp':
          event.preventDefault();
          this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
          this.updateSelection(items);
          break;
          
        case 'Enter':
          if (this.selectedIndex >= 0 && items[this.selectedIndex]) {
            event.preventDefault();
            const selectedItem = items[this.selectedIndex];
            const button = selectedItem.querySelector('.coveo-suggestion-button');
            if (button && button.dataset.suggestion) {
              this.selectSuggestion(button.dataset.suggestion);
            } else if (this.selectedIndex < this.suggestions.length) {
              // Fallback for regular suggestions
              const suggestion = this.suggestions[this.selectedIndex].expression || this.suggestions[this.selectedIndex];
              this.selectSuggestion(suggestion);
            } else if (this.selectedIndex < this.recentSearches.length) {
              // Fallback for recent searches
              this.selectSuggestion(this.recentSearches[this.selectedIndex]);
            }
          }
          break;
          
        case 'Escape':
          this.hideSuggestions();
          break;
      }
    }
    
    updateSelection(items) {
      items.forEach((item, index) => {
        if (index === this.selectedIndex) {
          item.classList.add('coveo-suggestion-selected');
          item.querySelector('button')?.focus();
        } else {
          item.classList.remove('coveo-suggestion-selected');
        }
      });
    }
    
    handleClickOutside(event) {
      if (!this.suggestionsContainer.contains(event.target) && 
          event.target !== this.searchInput) {
        this.hideSuggestions();
      }
    }
    
    getCustomerMetafield(fieldName) {
      const container = this.searchInput.closest('.coveo-search-box-form');
      if (!container) return '';
      
      // Try to get from data attributes
      const camelCaseField = `customer${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`;
      if (container.dataset && container.dataset[camelCaseField]) {
        return container.dataset[camelCaseField];
      }
      
      // Fallback: try to get from window object if set by Liquid
      if (window.customerData && window.customerData[fieldName]) {
        return window.customerData[fieldName];
      }
      
      return '';
    }
  }
  
  // Export class to window
  window.CoveoSearchBoxSuggestions = CoveoSearchBoxSuggestions;
  
  })(); // End of IIFE
  
  // Initialize when DOM is ready
  function initCoveoSearchBoxSuggestions() {
    // Prevent multiple initializations
    if (window.coveoSearchBoxSuggestionsInitialized) {
      return;
    }
    
    // Check if class is available
    if (typeof window.CoveoSearchBoxSuggestions === 'undefined') {
      console.warn('CoveoSearchBoxSuggestions class not available');
      return;
    }
    
    // Find all search inputs that should have Coveo suggestions
    const searchInputs = document.querySelectorAll('.coveo-search-box-input');
    
    searchInputs.forEach(input => {
      // Skip if already initialized
      if ((input instanceof HTMLElement) && input.dataset.coveoInitialized === 'true') {
        return;
      }
      
      // Find or create suggestions container
      const form = input.closest('.coveo-search-box-form');
      if (!form) {
        return;
      }
      
      let container = form.querySelector('.coveo-suggestions-container');
      
      // Create container if it doesn't exist
      if (!container) {
        container = document.createElement('div');
        container.className = 'coveo-suggestions-container';
        container.setAttribute('role', 'listbox');
        container.setAttribute('aria-label', 'Query suggestions');
        form.appendChild(container);
      }
      
      // Initialize Coveo suggestions
      try {
        new window.CoveoSearchBoxSuggestions(input, container);
        if (input instanceof HTMLElement) {
          input.dataset.coveoInitialized = 'true';
        }
      } catch (error) {
        console.error('Error initializing Coveo search box suggestions:', error);
      }
    });
    
    window.coveoSearchBoxSuggestionsInitialized = true;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCoveoSearchBoxSuggestions);
  } else {
    // DOM is already ready
    initCoveoSearchBoxSuggestions();
  }
  
  